import { useState } from 'react';
import {
  ParagraphWithEllipsis,
  Td,
} from '../../../../shared/TableComponents/StyledComponents';

const TdWithTooltip = ({ content, dataFor, className, as, color }) => {
  const [tooltipText, setTooltipText] = useState('');

  const onMouseHoverHandler = e => {
    const scrollWidth = e.currentTarget.children[0].scrollWidth;
    const clientWidth = e.currentTarget.children[0].clientWidth;

    const newTooltipText = scrollWidth > clientWidth ? content : '';

    setTooltipText(newTooltipText);
  };

  return (
    <Td
      data-tip={tooltipText}
      data-for={dataFor}
      onMouseEnter={onMouseHoverHandler}
      className={className}
    >
      <ParagraphWithEllipsis as={as} color={color}>
        {content}
      </ParagraphWithEllipsis>
    </Td>
  );
};

export default TdWithTooltip;
